import { gql } from '@apollo/client';

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($input: NotificationFilterArgs!) {
    notifications: getNotifications(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          institutionId
          registrationId
          monitoringFormId
          dueDate
          message
          startDate
          title
          topic
          notificationType
          read
        }
      }
    }
  }
`;
